import { PQR_TYPE_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { usePqrTypeList } from './hook';
import { PqrTypeListProps } from './props';

export const PqrTypeList = ({ filters }: PqrTypeListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        usePqrTypeList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${PQR_TYPE_DETAIL}/${item.id}`, '_blank')
            }
        />
    );
};
